import React, { PureComponent } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import routes from '~/features/base/routes/index';

import AppContainer from '~/features/base/components/AppContainer';
import DisclaimerDialog from '~/features/disclaimer/components/DisclaimerDialog';
import NetworkCodeList from '~/features/base/components/NetworkCodeList';

export class MainContainer extends PureComponent {
    render() {
        return (
            <AppContainer>
                <DisclaimerDialog/>
                <NetworkCodeList/>
                <Switch>
                    <Route path={'/'} component={routes}/>
                    <Redirect to={'/'} />
                    <Redirect to='/error'/>
                </Switch>
            </AppContainer>
        );
    }
}

export default MainContainer;
